import { CircularProgress } from '@mui/material';
import { useState } from 'react';
import { toast } from 'react-toastify';

const ChangeStateForm = ({
    currentTicket,
    changeTicketState,
    tab,
    isLoading,
    states,
}) => {
    const [motivo, setMotivo] = useState(null);
    const [state, setState] = useState(tab);

    const submitChangeState = (e) => {
        e.preventDefault();
        if (state === 'archivado' && !motivo) {
            return toast.error('El motivo es obligatorio!');
        }
        const data = { newState: state, ticketId: currentTicket.id };
        if (motivo) {
            data.observacionesInternas = motivo;
        }
        changeTicketState(data);
    };

    return (
        <form className="w-100 d-flex flex-column align-items-end justify-content-end">
            <select value={state} onChange={(e) => setState(e.target.value)}>
                {states.map((st) => (
                    <option key={st} value={st}>
                        {st}
                    </option>
                ))}
            </select>
            {state === 'archivado' ? (
                <>
                    <label className="w-100 mt-2">
                        Motivo de archivo del ticket (máximo 50 caracteres)
                        <textarea
                            type="text"
                            maxLength={50}
                            minLength={5}
                            value={currentTicket?.motivo}
                            name="motivo"
                            onChange={(e) => setMotivo(e.target.value)}
                        />
                    </label>
                </>
            ) : null}
            <button
                className="btn btn-primary mt-2 btn-modal-tickets"
                disabled={
                    state === 'archivado' && currentTicket?.motivo?.length < 5
                }
                onClick={submitChangeState}
            >
                {isLoading ? (
                    <CircularProgress color="inherit" size={18} />
                ) : (
                    'Guardar'
                )}
            </button>
        </form>
    );
};

export default ChangeStateForm;
